import axios from "axios";
import { appEnv } from "../appEnv";
import {
  setLanguageInterceptor,
  setTokenRequestInterceptor,
} from "./interceptors";

const apiData = axios.create({
  baseURL: appEnv.REACT_APP_DATA_API_URL,
  transitional: {
    clarifyTimeoutError: true,
  },
  params: {
    tupi_cache_purge: Date.now(),
  },
});

apiData.interceptors.request.use(setTokenRequestInterceptor);
apiData.interceptors.request.use(setLanguageInterceptor);

export default apiData;
